import "./newTicketSingleMass.scss";
import Sidebar from "../../components/sidebar/Sidebar";
import Navbar from "../../components/navbar/Navbar";
import {useEffect, useState} from "react";
import newRequest from "../../context/newRequest";
import {useNavigate, useParams} from "react-router-dom";
import useFetch from "../../hooks/useFetch";
import Select from "react-select";
import DataTableSolveNumberTicket from "../../components/DatatableSolveNumberTicket/DatatableSolveNumberTicket";
import {ticketSolvedColumns, ticketSolvedNumberColumns} from "../../datatablesource";
import {sleep} from "../../helper/helper";

const NewTicketSingleMass = ({ inputs, title, region }) => {
  const [ticketOpen, setTicketOpen] = useState({});
  const [sending, setSending] = useState("");
  const ticketId = useParams("ticketId");
  const navigate = useNavigate();
  const user = localStorage.getItem("user");


    const [options, setOptions] = useState([]);
    const [selectedOption, setSelectedOption] = useState(null);
    useEffect(() => {
        // Fetch data dari API
        const fetchData = async () => {
            try {
                const response = await newRequest.get(
                    "/allusers"
                );
                const formattedData = response.data.data.map((user) => ({
                    value: user.id,
                    label: user.id, // Menampilkan nama di dropdown
                }));
                setOptions(formattedData);
            } catch (error) {
                console.error("Error fetching data:", error);
            }
        };

        fetchData();
    }, []);



  const handleChanged = (e) => {
    setTicketOpen((prev) => ({ ...prev, [e.target.id]: e.target.value }));
  };

  const handleClick = async (e) => {
    e.preventDefault();
    try {
      setSending("On Submit")
      const newTicketOpen = {
        ...ticketOpen,
          user_id : selectedOption.value
      };

     const res= await newRequest.post(`/solve/mass/${ticketId.ticketId}`, newTicketOpen, {
        // headers
        headers: {
          'Authorization': `$Bearer ${user.token}`
        },
      } );
      setSending("Mengirim Submit")

      const data = res.data.data
      if (res.status === 200) {
        setSending("Submit Single Ticket GAMAS berhasil");
          navigate(`/solve/${ticketId.ticketId}`);
          await sleep(1000)
          navigate(`/solve/mass/${ticketId.ticketId}`);
      }

      console.log(res.status)
    } catch (err) {
      setSending(err.response.data.errors)
      console.log(err.response.data.data);
    }
  };

    const handleChange = (selectedOption) => {
        setSelectedOption(selectedOption);
        console.log("Selected option:", selectedOption);
    };
  return (
    <div className="new">
      <Sidebar />
        <div className="newContainer">
            <Navbar/>
            <h1>{title}</h1>
            <div className="tableminor">
                <DataTableSolveNumberTicket columns={ticketSolvedNumberColumns} ticketId={ticketId.ticketId}/>
            </div>

            <div className="bottom">
                <div className="right">
                    <form>
                        <div className="formInput">
                            <h1>Ticket Id : {ticketId.ticketId} </h1>
                            <br/>
                            <label>Segment Customer </label>
                            <textarea placeholder="segmet customer" onChange={handleChanged} id="segment_customer"/>
                            <div className="searchable-dropdown">
                                <h3>Select a User</h3>
                                <Select
                                    classNamePrefix="react-select"
                                    options={options}
                                    value={selectedOption}
                                    onChange={handleChange}
                                    isSearchable
                                    placeholder="Search or Select..."
                                />
                                {selectedOption && (
                                    <p>
                                        Selected: <strong>{selectedOption.label}</strong> (ID:{" "}
                                        {selectedOption.value})
                                    </p>
                                )}
                            </div>

                        </div>
                    </form>
                    <button onClick={handleClick}>Send</button>
                </div>
            </div>
            {sending && <p className="error">{sending}</p>}
            <br/>
            <br/>
            <br/>

            <br/>

        </div>
    </div>
  );
};

export default NewTicketSingleMass;
